const getResolutionData = (resolution) => {
  let width = ''
  let height = ''

  if (resolution) {
    const xSign = resolution.indexOf('x')
    if (xSign > -1) {
      width = resolution.slice(0, xSign)
      height = resolution.slice(xSign + 1, resolution.length)
    }
  }

  return { width, height }
}

export const getUserData = () => {
  const url = new URL(window.location.href)
  const searchParams = new URLSearchParams(url.search)

  const uid = searchParams.get('uid')
  const iid = searchParams.get('iid')

  const ram = searchParams.get('ram')
  const { width, height } = getResolutionData(searchParams.get('resolution'))

  const lang = searchParams.get('lang')
  const platform = searchParams.get('platform')
  const game = searchParams.get('game')
  const version = searchParams.get('version')
  const token = searchParams.get('token')
  const ts = searchParams.get('ts')
  const signature = encodeURIComponent(ts + ':' + token)

  const uaRaw = navigator.userAgent
  const uaFormatted = `Browser: ${uaRaw}`
  const userAgent = encodeURIComponent(uaFormatted)

  const timeRaw = new Date()
  const timeFormatted = `\nLocal time: ${timeRaw}`
  const localTime = encodeURIComponent(timeFormatted)
  const tsLog = Date.now()

  return {
    uid, iid, ram, width, height, lang, platform, game, version, signature, userAgent, localTime, tsLog
  }
}
